import * as Accordion from '@radix-ui/react-accordion';
import { WithChildren } from '../../types/component.types';
import { Icon } from '../Icon/Icon';
import { ListItemContent } from './ListItemContent';
import {
  AccordionListItemProps,
  listItem,
  trailingElementWrapper,
} from './ListTypes';

export const AccordionListItem = ({
  heading,
  body,
  background,
  children,
  value,
  leadingElement,
  trailingElement,
  trailingElementCentered = false,
  linkTo,
  collapsible = false,
  disabled = false,
  grouping,
  width,
  ...props
}: AccordionListItemProps) => {
  return (
    <li
      className={listItem({
        width: width || 'full',
        interaction: collapsible ? 'active' : 'hover',
        disabled,
        background,
        grouping,
      })}
    >
      <Accordion.Item
        value={value}
        className="w-full"
        aria-label={heading}
        aria-disabled={disabled}
        {...props}
      >
        <ConditionallyCollapsible collapsible={collapsible}>
          <Accordion.Header
            className="flex gap-s p-s group"
            aria-disabled={disabled}
          >
            <ListItemContent
              heading={heading}
              disabled={disabled}
              linkTo={linkTo}
              body={body}
              leadingElement={leadingElement}
            />

            {collapsible && (
              <div className="ml-auto">
                <Icon
                  name="keyboard_arrow_down"
                  animation="transform duration-200 group-rdx-state-open:rotate-180"
                  label="expand-collapse"
                />
              </div>
            )}
            {trailingElement && (
              <div
                className={trailingElementWrapper({
                  centered: trailingElementCentered,
                })}
              >
                {trailingElement}
              </div>
            )}
          </Accordion.Header>
        </ConditionallyCollapsible>

        {children &&
          (collapsible ? (
            <Accordion.Content className="overflow-auto max-h-[256px] pb-s px-m">
              {children}
            </Accordion.Content>
          ) : (
            <div className="pb-s px-s">{children}</div>
          ))}
      </Accordion.Item>
    </li>
  );
};

const ConditionallyCollapsible = (
  props: WithChildren & { collapsible: boolean },
) => {
  return props.collapsible ? (
    <Accordion.Trigger className="w-full text-start">
      {props.children}
    </Accordion.Trigger>
  ) : (
    <>{props.children}</>
  );
};
